import { render, staticRenderFns } from "./theGoodsitem.vue?vue&type=template&id=66d4e992&scoped=true&"
import script from "./theGoodsitem.vue?vue&type=script&lang=js&"
export * from "./theGoodsitem.vue?vue&type=script&lang=js&"
import style0 from "./theGoodsitem.vue?vue&type=style&index=0&id=66d4e992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d4e992",
  null
  
)

export default component.exports